import {
  type RelationCollection,
  relationCollectionSchema,
  type Relation,
  relationSchema, relationFilterSchema, type RelationFilter,
} from '@/types/Wiser/relation.ts'

import { createRestApi, type HttpClient, type ModelApi } from '@jantm/model-core'

export type RelationApi = ModelApi<Relation, RelationCollection, RelationFilter>

/**
 * The HTTP client is injected rather than imported so this package never pins
 * an axios instance, a base URL, or an auth interceptor — the host application
 * owns all three.
 */
export function createRelationApi(
  client: HttpClient,
  endpoint = '/wiser/relatie',
): RelationApi {
  return createRestApi({
    client,
    endpoint,
    schema: relationSchema,
    collectionSchema: relationCollectionSchema,
    filterSchema: relationFilterSchema,
  })
}
